import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import "@/App.css";
import LangLayout from "@/components/LangLayout";
import ScrollToTop from "@/lib/scroll";
import Home from "@/pages/Home";
import LegalPage from "@/pages/LegalPage";
import ThankYou from "@/pages/ThankYou";

function detectLang() {
  try {
    const stored = localStorage.getItem("rv_lang");
    if (stored === "ar" || stored === "en") return stored;
  } catch (e) {}
  if (typeof navigator !== "undefined") {
    const nav = (navigator.language || "").toLowerCase();
    if (nav.startsWith("es")) return "ar";
    return "en";
  }
  return "ar";
}

function RootRedirect() {
  const nav = useNavigate();
  useEffect(() => {
    nav(`/${detectLang()}`, { replace: true });
  }, [nav]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<RootRedirect />} />
          <Route path="/thank_you" element={<ThankYou />} />
          <Route path="/:lang" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<LegalPage i18nRoot="privacy" />} />
            <Route path="cookies" element={<LegalPage i18nRoot="cookiesPage" />} />
            <Route path="terms" element={<LegalPage i18nRoot="terms" />} />
          </Route>
          <Route path="*" element={<Navigate to="/ar" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
